import { IResourceConfig } from '@/Core/Contracts/UI'
import { MdKey } from 'react-icons/md'

export const ManualTokenResource: IResourceConfig = {
    title: 'Ручні токени',
    fields: {
        id: {
            label: 'ID',
            type: 'number',
            inputProps: { disabled: true },
            /** У фільтрі: оператор (=, >, ≥, <, ≤) або діапазон від–до */
            isFilterRange: true,
        },
        title: {
            label: 'Назва',
            type: 'string',
        },
        externalCode: {
            label: 'Зовнішній код',
            type: 'string',
        },
        isActive: {
            label: 'Активний',
            type: 'switch',
        },
        user: {
            label: 'Користувач',
            type: 'select',
            resource: 'Setting.User',
            isRequired: true,
            /** У фільтрі — кілька користувачів (user.uuid in […]) */
            isFilterMultiple: true,
        },
        expiresAt: {
            label: 'Дата закінчення',
            type: 'datetime',
            isRequired: true,
        },
        token: {
            label: 'Токен (JWT)',
            type: 'textarea',
            inputProps: { disabled: true, rows: 4 },
        },
        description: {
            label: 'Опис',
            type: 'textarea',
        },
        createdAt: {
            label: 'Дата створення',
            type: 'datetime',
            inputProps: { disabled: true },
        },
        updatedAt: {
            label: 'Дата оновлення',
            type: 'datetime',
            inputProps: { disabled: true },
        },
    },
    table: {
        showColumns: ['id', 'title', 'user', 'expiresAt', 'isActive', 'createdAt'],
    },
    filter: {
        includeFields: ['id', 'title', 'user', 'expiresAt', 'isActive'],
    },
    restUrl: '/services/manual-tokens',
    pageUrl: '/settings/manual-tokens',
    pageConfig: {
        title: 'Ручні токени',
        icon: <MdKey />,
    },
    settings: {
        searchFields: ['id', 'title', 'externalCode'],
        AddDrawerModeCrudFeature: {
            enableMenuDeleteItem: true,
        },
    },
}
